import { CSSObject } from '@emotion/react'
import { fontSizes, fontWeights, fonts } from '@opallabs/pulsar'
import { colors } from '@opallabs/spectrum'

// Styling for retweet wrapper placeholder and input text
const retweetWrapperText: CSSObject = {
  border: 'none',
  fontFamily: fonts.sansSerif,
  fontWeight: fontWeights.bold,
  fontSize: fontSizes.xSmall,
  width: '193px',
  outline: 'none',
  color: colors.n5.base,
}

// Styling for loader to unset positioning and background
const getLoaderWrapper = (isLoading: boolean): CSSObject => ({
  padding: '16px 10px 16px 10px',
  borderRadius: '2px',
  backgroundColor: colors.n10.base,
  '.kuiper-loader-container': {
    position: 'unset',
    margin: '9px 0 9px 0',
  },
  display: isLoading ? 'block' : 'none',
})

const styles = {
  getLoaderWrapper,
  retweetWrapperText,
}

export { styles }
